import React from 'react'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'
import moment from 'moment'
import {Form, Radio} from 'antd'
import {DATE_TIME_FORMAT} from '@/constants'
import {disabledDateBeforeNow, disabledTimeBeforeNow} from '@/utils'
import {getExpirationDateByPreset} from '@/services/payment-link'
import {ExpirationDateType} from '@/stores/pay-by-link/models/ExpirationDateType'
import DatePicker from '~/code/components/dumb/DatePicker/DatePicker'
import {
    NEW_PAYMENT_EXPIRATION_DATE,
    NEW_PAYMENT_EXPIRATION_DATE_TYPES,
    TWENTY_FOUR_HOURS_EXPIRE_DATE,
    FOURTY_EIGHT_HOURS_EXPIRE_DATE,
    WEEK_EXPIRE_DATE,
    MONTH_EXPIRE_DATE
} from '@/constants/playwright-ids'

import {ExpirationDateFieldProps} from './props'
import styles from './styles.scss'

export const ExpirationDateField: React.FC<ExpirationDateFieldProps> = ({
    form,
    visible = true,
    required = true,
    name = 'expirationDate',
    presetName = 'expirationDatePreset',
    label = i18next.t('ExpirationDateField.labels.linkExpiration')
}) => {
    if (!visible) return null

    const {t} = useTranslation()

    return (
        <Form.Item
            label={label}
            name={name}
            rules={
                required
                    ? [
                          {
                              required: true,
                              message: t('ExpirationDateField.errors.linkExpirationRequired')
                          }
                      ]
                    : []
            }
            data-test-id={NEW_PAYMENT_EXPIRATION_DATE}
        >
            <DatePicker
                format={DATE_TIME_FORMAT}
                showTime={{defaultValue: moment().add(15, 'minutes')}}
                placeholder={t('ExpirationDateField.selectDate')}
                showNow={false}
                showSecond={false}
                popupClassName={styles.popupDropdown}
                disabledDate={disabledDateBeforeNow}
                disabledTime={disabledTimeBeforeNow}
                onChange={() => form.resetFields([presetName])}
                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                renderExtraFooter={() => (
                    <Form.Item noStyle name={presetName}>
                        <Radio.Group
                            className={styles.radio}
                            data-test-id={NEW_PAYMENT_EXPIRATION_DATE_TYPES}
                            onChange={(e) =>
                                form.setFieldValue(name, getExpirationDateByPreset(e.target.value))
                            }
                        >
                            <Radio
                                value={ExpirationDateType.Hour24}
                                data-test-id={TWENTY_FOUR_HOURS_EXPIRE_DATE}
                            >
                                {t('ExpirationDateField.ranges.hour24')}
                            </Radio>
                            <Radio
                                value={ExpirationDateType.Hour48}
                                data-test-id={FOURTY_EIGHT_HOURS_EXPIRE_DATE}
                            >
                                {t('ExpirationDateField.ranges.hour48')}
                            </Radio>
                            <Radio value={ExpirationDateType.Week1} data-test-id={WEEK_EXPIRE_DATE}>
                                {t('ExpirationDateField.ranges.week1')}
                            </Radio>
                            <Radio
                                value={ExpirationDateType.Month1}
                                data-test-id={MONTH_EXPIRE_DATE}
                            >
                                {t('ExpirationDateField.ranges.month1')}
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                )}
            />
        </Form.Item>
    )
}
